<template>
  <div class="items-center font-primary text-sm text-gris gap-xs">
    <VaimoIcon :size="12" icon="info_gris_12" />
    {{
      $t('checkout.auth.registration.form.subscriptions.confirmation-message')
    }}
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'WillSendConfirmationMessage'
});
</script>
